import {
  exportFileSourceSchema,
  exportFileStatusSchema,
  ftpAccountSchema,
  storeCodeSchema,
} from '@flux/shared';
import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FilesPage } from '@/features/files/files-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/fichiers` — écran Fichiers CSV et envois (`02` §5). `validateSearch`
 * documente le contrat d'URL ; l'écran lui-même lit ces mêmes clés de façon
 * générique (`useSearch({strict:false})`, comme `useOriginFilter` et
 * `useDataTableUrlState`) pour rester testable isolément — voir le rapport de
 * la vague.
 */
const filesSearchSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  sortBy: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  store: storeCodeSchema.optional(),
  source: exportFileSourceSchema.optional(),
  ftpAccount: ftpAccountSchema.optional(),
  status: z.array(exportFileStatusSchema).optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  search: z.string().optional(),
});

export const filesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/fichiers',
  validateSearch: (search: Record<string, unknown>) => filesSearchSchema.parse(search),
  component: FilesPage,
});

/** Exporté en tableau pour la composition centrale (`src/router.tsx`, hors périmètre de cette vague). */
export const filesRoutes = [filesRoute];
